import React from "react";
import AppRouter from "./router/AppRouter";

export default function App() {
  return <AppRouter />;
}